document.addEventListener("DOMContentLoaded", function() {
  const currencyCurrent = document.querySelector(".currency__current");
  const currencySwitcher = document.querySelector(".currency__switcher");

  // Create dropdown container
  const dropdown = document.createElement("div");
  dropdown.classList.add("dropdown");

  // Clone the currency__current element for the dropdown toggle
  const dropdownToggle = currencyCurrent.cloneNode(true);
  dropdownToggle.classList.add("dropdown-toggle");
  dropdown.appendChild(dropdownToggle);

  // Create dropdown menu container
  const dropdownMenu = document.createElement("div");
  dropdownMenu.classList.add("dropdown-menu");

  // Move currencySwitcher options to the dropdown menu
  while (currencySwitcher.firstChild) {
      dropdownMenu.appendChild(currencySwitcher.firstChild);
  }

  dropdown.appendChild(dropdownMenu);

  // Replace the original currencyCurrent with the dropdown
  currencyCurrent.parentNode.replaceChild(dropdown, currencyCurrent);

  // Add event listener to toggle the dropdown
  dropdownToggle.addEventListener("click", function(event) {
      event.stopPropagation(); // Stop the click event from propagating to the document
      dropdownMenu.classList.toggle("show");
      dropdownToggle.classList.toggle("active");
  });

  // Close dropdown when clicking outside
  document.addEventListener("click", function(event) {
      if (!dropdown.contains(event.target)) {
          dropdownMenu.classList.remove("show");
          dropdownToggle.classList.remove("active");
      }
  });
});
